export default __webpack_public_path__ + "static/logo@2x-9c0c6319eeb32f7e347bab96d42824d6.png";